// noinspection JSAnnotator

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ConfirmationService, FilterMetadata, LazyLoadEvent, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {TableRequest} from "../../model/api/table-request";
import {Table} from "primeng/table";
import * as XLSX from "xlsx";
import {BookType} from "xlsx";
import {CcBaseComponent} from "../cc-base.component";
import {ExportAsService} from "ngx-export-as";
import {TableColumnConfig} from "../../model/api/table-column-config";
import {DateTime} from "luxon";
import {ContextMenu} from "primeng/contextmenu";
import {AppComponent} from "../../app.component";
import {CcCellDispatcherComponent} from "./cell-dispatcher/cc-cell-dispatcher.component";

import {TableButtonConfig} from "../../model/api/table-button-config";

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CctableBaseComponent extends CcBaseComponent {

  @Input()
  tableConfig: TableColumnConfig[] = [];

  @Input()
  records: any[] = [];

  @Input()
  totalRecords: number = 0;

  @Input()
  loading: boolean = false;

  @Input()
  scrollHeight: string = 'flex';

  @Input()
  currentRequest: TableRequest;

  @Output()
  loadRecordsEvent = new EventEmitter<TableRequest>();

  @Output()
  filterChangedEvent = new EventEmitter<TableRequest>();
  @Output()
  sortChangedEvent = new EventEmitter<TableRequest>();

  @Output()
  onClearFilter = new EventEmitter<TableRequest>();

  //translation part key
  @Input()
  transPartKey: String;

  //record field keys
  @Input()
  fieldId: string;

  @Input()
  fieldName: string;

  @Input()
  fieldEnabled: string;

  @Input()
  defaultSortField: string;

  @Input()
  defaultSortOrder: number = 1;

  @Input()
  disableContextMenu: boolean = false;

  @Input()
  disableSelection: boolean = false;

  @Input()
  disableFilters: boolean = false;

  globalFilterValue: string;

  @Output()
  onRowRightClick = new EventEmitter<any>();

  @Output()
  onRowDblClick = new EventEmitter<any>();

  @Output()
  onCtrlShift = new EventEmitter<any>();

  @Output()
  onShift_S = new EventEmitter<any>();

  @ViewChild('ccTable')
  ccTable: Table;

  @ViewChild('tableContextMn')
  tableContextMn: ContextMenu;

  @ViewChildren('ccCell')
  ccCells: QueryList<CcCellDispatcherComponent>;

  ctrlHitLastTime: DateTime;
  shiftHitLastTime: DateTime;
  repeatTimeDiff: number = 300;

  selectedCellValue = undefined;
  selectedCellColumnConfig = undefined;

  focused: boolean = false;
  focusedRowIndex: number = -1;


  constructor(protected el: ElementRef,
              cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService, private exportAsService: ExportAsService) {
    super(cdref, messageService, translateService);
    this.ctrlHitLastTime = DateTime.fromMillis(0);
    this.shiftHitLastTime = DateTime.fromMillis(0);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  public loadRecords(event: LazyLoadEvent) {
    const newRequest = new TableRequest(event)
    this.loadRecordsFromRequest(newRequest);
  }

  public loadRecordsFromRequest(newRequest: TableRequest) {
    if (!this.currentRequest || JSON.stringify(this.currentRequest.originEvent) != JSON.stringify(newRequest.originEvent)) {
      this.loadRecordsEvent.emit(newRequest);
    }
  }

  protected removeFilter(columnConfig: TableColumnConfig) {
    this.setFilter(columnConfig, undefined);
    // this.reloadTableValueMap();
    // if (table.filters[key])
    //   (<FilterMetadata>table.filters[key]).value = null;
    // table.filteredValue = null;
    // table.tableService.onResetChange();
    //
    // const request = Object.assign({}, this.currentRequest);
    // const index = request.filters.findIndex(value => value.field === key);
    // if (index > -1)
    //   request.filters.splice(index, 1);
    //
    // this.loadRecordsEvent.emit(request);
  }

  public setFilter(columnConfig: TableColumnConfig, filterValue: string) {
    const matchMode = columnConfig.filterConfig.matchMode ? columnConfig.filterConfig.matchMode : 'equals';

    // if (this.ccTable.filterTimeout) {
    //   clearTimeout(this.ccTable.filterTimeout);
    // }
    if (!this.ccTable.isFilterBlank(filterValue)) {
      this.ccTable.filters[columnConfig.field] = [{
        value: filterValue,
        matchMode: matchMode,
        operator: 'and'
      }];
      this.ccTable._filter();
      // const filter: FilterMetadata[] = this.ccTable.filters[columnConfig.field] as FilterMetadata[];
      // if (filter) {
      //   if (filter['value']) {
      //     filter['value'].value=filterValue;
      //     filter['value'].matchMode=matchMode;
      //     filter['value'].operator= 'and';
      //   } else if (filter[0] && filter[0].value) {
      //     filter[0].value=filterValue;
      //     filter[0].matchMode=matchMode;
      //     filter[0].operator= 'and';
      //   }else{
      //     this.ccTable.filters[columnConfig.field] = [{value: filterValue, matchMode: matchMode, operator: 'and'}];
      //   }
      // } else {
      //   this.ccTable.filters[columnConfig.field] = [{value: filterValue, matchMode: matchMode, operator: 'and'}];
      // }
      // this.ccTable.filter(filterValue, columnConfig.field, matchMode);
    } else if (this.ccTable.filters[columnConfig.field]) {
      const filter: FilterMetadata[] = this.ccTable.filters[columnConfig.field] as FilterMetadata[];
      if (filter) {
        let filterValue: FilterMetadata = undefined;
        if (filter['value']) {
          filterValue = filter['value'];
        } else if (filter[0] && filter[0].value) {
          filterValue = filter[0].value;
        }
        if (filterValue) {
          this.ccTable.filters[columnConfig.field] = [{
            value: undefined,
            matchMode: filterValue.matchMode,
            operator: filterValue.operator
          }];
        }
      }
    }

    // this.ccTable.filterTimeout = setTimeout(() => {
    //   this.ccTable._filter();
    //   this.ccTable.filterTimeout = null;
    // }, this.ccTable.filterDelay);

    // this.ccTable.anchorRowIndex = null;

    // this.reloadTableValueMap();
  }

  public setFiltersAndSort(request: TableRequest): void {

    // if (this.ccTable.filterTimeout) {
    //   clearTimeout(this.ccTable.filterTimeout);
    // }

    if (request.filters.length == 0) {
      for (let filtersKey in this.ccTable.filters) {
        // delete this.ccTable.filters[filtersKey];
        const filter: FilterMetadata[] = this.ccTable.filters[filtersKey] as FilterMetadata[];
        if (filter) {
          let filterValue: FilterMetadata = undefined;
          if (filter['value']) {
            filterValue = filter['value'];
          } else if (filter[0] && filter[0].value) {
            filterValue = filter[0].value;
          }
          if (filterValue) {
            this.ccTable.filters[filtersKey] = [{
              value: undefined,
              matchMode: filterValue.matchMode,
              operator: filterValue.operator
            }];
          }
        }
      }
    } else {
      request.filters.forEach(filter => {
        if (!this.ccTable.isFilterBlank(filter.value)) {
          this.ccTable.filters[filter.field] = [{
            value: filter.value,
            matchMode: filter.matchMode,
            operator: 'and'
          }];
        } else if (this.ccTable.filters[filter.field]) {
          // delete this.ccTable.filters[filter.field];
          this.ccTable.filters[filter.field] = [{
            value: undefined,
            matchMode: filter.matchMode,
            operator: filter.operator
          }];
        }
        if (filter.field === 'global')
          this.globalFilterValue = request.globalFilter;
      });
    }
    this.ccTable._filter();

    if (request.globalFilter) {
      this.ccTable.filters['global'] = {value: request.globalFilter, matchMode: 'contains', operator: 'and'};
      request.filters.push({value: request.globalFilter, matchMode: 'contains', operator: 'and'});
      this.globalFilterValue = request.globalFilter;
      this.ccTable.filterGlobal(request.globalFilter, 'contains');
    }

    // this.ccTable.filterTimeout = setTimeout(() => {
    //   this.ccTable._filter();
    //   this.ccTable.filterTimeout = null;
    // }, this.ccTable.filterDelay);

    this.ccTable.sortField = request.sortField;
    this.ccTable.sortOrder = request.sortOrder;

    // this.ccTable.anchorRowIndex = null;
    // const sOption: ScrollToOptions = {top: 200, left:0, behavior: 'auto'};
    // this.ccTable.scrollTo(sOption);
    // this.ccTable.scrollToVirtualIndex(200);
    // setTimeout(() => {
    this.reloadTableValueMap();
    // });

  }

  protected hasFilter(): boolean {
    let hasFilter: boolean = false;
    // if (this.currentRequest) {
    //   if (this.currentRequest.globalFilter && this.currentRequest.globalFilter.length > 0) {
    //     console.log("------> this.currentRequest.globalFilter "+this.currentRequest.globalFilter)
    //     hasFilter = true;
    //   } else {
    //     this.currentRequest.filters.forEach(filter => {
    //       if (filter.value) {
    //         hasFilter = true;
    //       }
    //     });
    //   }
    // }
    if (this.globalFilterValue)
      hasFilter = true;
    else if (this.ccTable) {
      for (let key in this.ccTable.filters) {
        if (key != 'global') {
          const filter: FilterMetadata[] = this.ccTable.filters[key] as FilterMetadata[];
          if (filter && (filter['value'] || filter[0] && filter[0].value)) {
            hasFilter = true;
            break;
            // newEventFilter[key] = {...this.originEvent.filters[key]};
          }
        }
      }
      // console.log("------> this.ccTable. " +
      //   JSON.stringify(this.globalFilterValue))
      // console.log("------> this.ccTable. " +
      //   JSON.stringify((this.ccTable.filters)))
    }
    return hasFilter;
  }

  // protected clearSort() {
  //   const globalFilterValue = this.globalFilterValue;
  //   const tableFilters = {...this.ccTable.filters};
  //   this.ccTable.sortField = (this.defaultSortField || this.defaultSortField === '' ? this.defaultSortField : this.fieldName);
  //   this.ccTable.sortOrder = this.defaultSortOrder != undefined ? this.defaultSortOrder : 1;
  //
  //   this.ccTable.reset();
  //   this.ccTable.clear();
  //   this.ccTable._sortField = this.ccTable.sortField;
  //   this.ccTable._sortOrder = this.ccTable.sortOrder;
  //   this.ccTable._multiSortMeta = [{field: this.ccTable.sortField, order: this.ccTable.sortOrder}];
  //   this.ccTable.tableService.onSort({field: this.ccTable.sortField, order: this.ccTable.sortOrder});
  //   // if (!this.currentRequest) {
  //
  //   this.ccTable.sortSingle();
  //   this.ccTable.filters = tableFilters;
  //   this.globalFilterValue = globalFilterValue;
  //   for (let key in tableFilters) {
  //     if (key != 'global') {
  //       const filter: FilterMetadata[] = this.ccTable.filters[key] as FilterMetadata[];
  //       if (filter && filter[0].value) {
  //         this.ccTable.filter(filter[0].value.value, filter[0].value.value, filter[0].value.matchMode);
  //       }
  //     }
  //   }
  //   this.ccTable.filterGlobal(globalFilterValue, 'contains');
  //   // }
  //   // this.currentRequest.sortField = this.ccTable.sortField;
  //   // this.currentRequest.sortOrder = this.ccTable.sortOrder;
  //   // const request = Object.assign({}, this.currentRequest);
  //   // request.sortField = this.ccTable.sortField;
  //   // request.sortOrder = this.ccTable.sortOrder;
  //   // request.originEvent.sortField = this.ccTable.sortField;
  //   // request.originEvent.sortOrder = this.ccTable.sortOrder;
  //   // this.loadRecordsEvent.emit(request);
  //   // this.filterChangedEvent.emit(request);
  //   this.reloadTableValueMap();
  // }

  protected clearFilter() {

    const sortField = this.ccTable.sortField;
    const sortOrder = this.ccTable.sortOrder;
    this.globalFilterValue = undefined;

    setTimeout(() => {
      this.ccTable.clear();
      this.ccTable._filter();
      this.ccTable.sortField = sortField;
      this.ccTable.sortOrder = sortOrder;
      this.ccTable.sortSingle();
    });
    setTimeout(() => {
      if (this.currentRequest) {
        const newRequest = new TableRequest(this.currentRequest.originEvent)

        newRequest.globalFilter = undefined;
        newRequest.filters.splice(0);
        this.setFiltersAndSort(newRequest);
        this.loadRecordsFromRequest(newRequest);
      }
      this.onClearFilter.emit();
      this.reloadTableValueMap();
    });
  }

  //
  // private refillFilters() {
  //   this.tableConfig.forEach(columnConf => {
  //     const filter: FilterMetadata[] = this.ccTable.filters[columnConf.field] as FilterMetadata[];
  //     if (!filter) {
  //       // this.ccTable.filters[columnConf.field] = [{
  //       //   value: undefined,
  //       //   matchMode: this.selectedCellColumnConfig.filterConfig.matchMode ? this.selectedCellColumnConfig.filterConfig.matchMode : 'equals',
  //       //   operator: 'and'
  //       // }];
  //       this.ccTable.filter(undefined, columnConf.field,
  //         this.selectedCellColumnConfig.filterConfig.matchMode ? this.selectedCellColumnConfig.filterConfig.matchMode : 'equals');
  //     }
  //   });
  // }

  protected clearSort() {

    const globalFilterValue = this.globalFilterValue;
    const tableFilters = {...this.ccTable.filters};

    setTimeout(() => {
      this.ccTable.clear();
      this.ccTable.sortField = (this.defaultSortField || this.defaultSortField === '' ? this.defaultSortField : this.fieldName);
      this.ccTable.sortOrder = this.defaultSortOrder != undefined ? this.defaultSortOrder : 1;
      this.ccTable.sortSingle();
      this.ccTable.filters = tableFilters;
      this.globalFilterValue = globalFilterValue;
      this.ccTable._filter();
      if (globalFilterValue) {
        this.ccTable.filterGlobal(globalFilterValue, 'contains');
      }
    });

  }

  protected hasSort(): boolean {
    // if(this.currentRequest) {
    //   console.log("------> currentRequest.sortOrder " + this.currentRequest.sortOrder)
    //   console.log("------> currentRequest.sortField " + this.currentRequest.sortField)
    // }
    // console.log("------> defaultSortOrder "+this.defaultSortOrder )
    // console.log("------> defaultSortField "+this.defaultSortField )
    // console.log("------> fieldName "+this.fieldName )
    // console.log("------>" )
    if (this.currentRequest) {
      if (this.currentRequest && this.currentRequest.sortField == null) this.currentRequest.sortField = (this.defaultSortField || this.defaultSortField === '' ? this.defaultSortField : this.fieldName);
      return this.currentRequest && (this.currentRequest.sortOrder != this.defaultSortOrder
        || this.currentRequest.sortField !== (this.defaultSortField || this.defaultSortField === '' ? this.defaultSortField : this.fieldName));
    } else {
      return this.ccTable && (this.ccTable.sortField != this.defaultSortField ||
        this.ccTable.sortOrder != this.defaultSortOrder);
    }
  }

  public exportRecords(type: BookType) {
    const tempReportRecords = [];
    const columnKeys = this.tableConfig.map(value => value.field);
    this.records.forEach(record => {
      const tempNewRecord = {};
      this.flatenObject(record, columnKeys, tempNewRecord);
      tempReportRecords.push(tempNewRecord);
    });
    const worksheet = XLSX.utils.json_to_sheet(tempReportRecords);
    const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer: any = XLSX.write(workbook, {bookType: type, type: 'array'});
    this.saveAsExcelFile(excelBuffer,
      this.translateService.instant('page.' + this.transPartKey + '.item_name').toLowerCase() + 's',
      type);
    this.loading = false;
  }

  private flatenObject(record, columnKeys: string[], tempNewRecord: {}) {
    for (let key in record) {
      let value = record[key];
      if (columnKeys.includes(key)) {
        let value = record[key];
        if (value && Array.isArray(value)) {
          tempNewRecord[key] = value.join(', ');
        } else if (value && DateTime.isDateTime(value)) {
          tempNewRecord[key] = value.toFormat('yyyy-MM-dd HH:mm:ss');
        } else if (value && typeof value === 'object') {
          this.flatenObject(value, columnKeys, tempNewRecord);
        } else {
          tempNewRecord[key] = value;
        }
      } else if (value && !Array.isArray(value) && !DateTime.isDateTime(value) && typeof value === 'object') {
        this.flatenObject(value, columnKeys, tempNewRecord);
      }
    }
  }

  protected saveAsExcelFile(buffer: any, fileName: string, type: BookType): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    if (type === 'csv') {
      EXCEL_TYPE = 'text/x-csv';
      EXCEL_EXTENSION = '.csv';
    }
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    this.exportAsService.downloadFromBlob(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // private saveAsPDFFile(): void {
  //   var doc = new jsPDF.jsPDF({putOnlyUsedFonts: true, orientation: "landscape"});
  //
  //   function createHeaders(keys, position: number, size: number) {
  //     var result = [];
  //     for (var i = position; i < size; i += 1) {
  //       result.push({
  //         id: keys[i],
  //         name: keys[i],
  //         prompt: keys[i],
  //         width: 65,
  //         align: "center",
  //         padding: 0
  //       });
  //     }
  //     return result;
  //   }
  //
  //   const cols = [];
  //   if (this.records && this.records.length > 0) {
  //     for (const [key, value] of Object.entries(this.records[0])) {
  //       cols.push(key);
  //     }
  //   }
  //
  //   function createRows(records: any, position: number, size: number) {
  //     const stMawWidth = 25;
  //     const rows = [];
  //     // var rows1 = [];
  //     records.forEach(record => {
  //       const row = {};
  //       let count = 0;
  //       for (const [key, value] of Object.entries(record)) {
  //         let valueSt = ' ';
  //         if (typeof value === 'string') {
  //           valueSt = value;
  //         } else {
  //           valueSt = JSON.stringify(value);
  //         }
  //         if (valueSt.length > stMawWidth) {
  //           valueSt = valueSt.slice(0, stMawWidth - 3) + '...'
  //         }
  //         row[key] = valueSt;
  //         count++;
  //         if (count < position) {
  //           continue;
  //         } else if (count === size) {
  //           break;
  //         }
  //       }
  //       rows.push(row);
  //     });
  //     return rows;
  //   }
  //
  //   const colPerTable = 10;
  //   if (cols.length < colPerTable) {
  //     doc.table(1, 1, createRows(this.records, 0, cols.length), createHeaders(cols, 0, cols.length),
  //       {autoSize: true, css: {'font-size': 0.5}});
  //   } else {
  //     let position = 0;
  //     let size = colPerTable;
  //     for (let i = 0; i < cols.length / colPerTable; i++) {
  //       const yPos = i == 0 ? 1 : i * 12 * this.records.length;
  //       doc.table(1, yPos, createRows(this.records, position, size), createHeaders(cols, position, size),
  //         {autoSize: true, css: {'font-size': 0.5}});
  //       position += colPerTable;
  //       size = size + colPerTable < cols.length ? size + colPerTable : cols.length;
  //     }
  //   }
  //
  //   // doc.autoTable(col, rows, { startY: 10 });
  //   //   // doc.fill(this.records);
  //   const fileName = this.translateService.instant('page.' + this.transPartKey + '.item_name').toLowerCase() + 's';
  //   doc.save(fileName);
  //   // });
  //   // // @ts-ignore
  //   // const doc = new jspdf.default();
  //   // doc.fromObject(this.records);
  //   // const fileName = this.translateService.instant('page.' + this.transPartKey + '.item_name').toLowerCase() + 's';
  //   // doc.save(fileName);
  //   // html2pdf()
  //   // var pdf = new jsPDF('lanscape');
  //   // const worksheet = html2pdf.js.utils.json_to_sheet(this.records);
  //   // const data: Blob = new Blob([buffer], {
  //   //   type: 'application/pdf'
  //   // });
  //   // this.exportAsService.downloadFromBlob(data, fileName + '_export_' + new Date().getTime() + '.pdf');
  // }

  public reloadTableValueMap() {
    this.markForCheck();
    this.ccCells?.forEach(cell => {
      cell.markForCheck();
    });
  }

  selectCell($event: MouseEvent, columnDef: TableColumnConfig, recordValue: any) {
    if (this.disableFilters) return;
    if (!columnDef.notFilterable) {
      this.selectedCellValue = recordValue;
      this.selectedCellColumnConfig = columnDef;
    } else {
      this.selectedCellValue = undefined;
      this.selectedCellColumnConfig = undefined;
    }
  }

  @HostListener('document:keydown.control.alt', ['$event'])
  onFilterCellValueAlt(e) {
    if (this.disableFilters) return;
    if (!this.focused) return;

    this.scrollToTop();

    if (this.selectedCellValue && this.selectedCellColumnConfig) {
      if (this.currentRequest) {
        const newRequest = new TableRequest(this.currentRequest.originEvent);

        const filter = newRequest.filters.find(
          value => value.field === this.selectedCellColumnConfig.field
        );

        if (filter) {
          if (filter.value == this.selectedCellValue) {
            filter.value = undefined;
          } else {
            filter.value = this.selectedCellValue;
          }
        } else {
          const matchMode =
            this.selectedCellColumnConfig.filterConfig &&
            this.selectedCellColumnConfig.filterConfig.matchMode
              ? this.selectedCellColumnConfig.filterConfig.matchMode
              : 'equals';

          newRequest.filters.push({
            field: this.selectedCellColumnConfig.field,
            matchMode,
            operator: 'and',
            value: this.selectedCellValue
          });
        }

        this.setFiltersAndSort(newRequest);
        this.loadRecordsFromRequest(newRequest);

        this.selectedCellValue = undefined;
        this.selectedCellColumnConfig = undefined;
      } else {
        this.setFilter(this.selectedCellColumnConfig, this.selectedCellValue);
        this.reloadTableValueMap();

        this.selectedCellValue = undefined;
        this.selectedCellColumnConfig = undefined;
      }
    } else {
      this.clearFilter();
    }

    this.onShCtFilter();
  }

  onShCtFilter() {
  }

  selectKeyUp($event: KeyboardEvent) {
  }

  selectKeyDown($event: KeyboardEvent) {
  }

  @HostListener('document:keydown.ArrowDown', ['$event'])
  @HostListener('document:keydown.shift.ArrowDown', ['$event'])
  // @HostListener('document:keyup.ArrowDown', ['$event'])
  // @HostListener('document:keyup.shift.ArrowDown', ['$event'])
  rowSelectDownShortCut(e) {
    if (this.disableSelection) return;
    if (!this.focused) return;
    this.selectKeyDown(e);
  }

  @HostListener('document:keydown.ArrowUp', ['$event'])
  @HostListener('document:keydown.shift.ArrowUp', ['$event'])
  // @HostListener('document:keyup.ArrowUp', ['$event'])
  // @HostListener('document:keyup.shift.ArrowUp', ['$event'])
  rowSelectUpShortCut(e) {
    if (this.disableSelection) return;
    if (!this.focused) return;
    const now = Date.now();
    this.selectKeyUp(e);
  }

  @HostListener('document:keydown.control.shift', ['$event'])
  rowDblClickShortCut(e) {
    if (!this.focused) return;
    // if (this.el.nativeElement.contains(e.target)) {
    this.onCtrlShift.emit();
    //}
  }

  @HostListener('document:keydown.shift.s', ['$event'])
  rowShiftSShortCut(e) {
    if (!this.focused) return;
    // if (this.el.nativeElement.contains(e.target)) {
    this.onShift_S.emit();
    //}
  }

  @HostListener('document:keyup.control', ['$event'])
  ctrlRepeat(e) {
    if (!this.focused) return;
    // if (this.el.nativeElement.contains(e.target)) {
    const newTime: DateTime = DateTime.now();
    if (newTime.diff(this.ctrlHitLastTime).milliseconds < this.repeatTimeDiff) {
      this.clearFilter();
    }
    this.ctrlHitLastTime = newTime;
    // }
  }

  @HostListener('document:keyup.shift', ['$event'])
  shiftRepeat(e) {
    if (!this.focused) return;
    // if (this.el.nativeElement.contains(e.target)) {
    const newTime: DateTime = DateTime.now();
    if (newTime.diff(this.shiftHitLastTime).milliseconds < this.repeatTimeDiff) {
      this.clearSort();
    }
    this.shiftHitLastTime = newTime;
    // }
  }

  focuseIn(rowIndex, mouseover = false) {
    const canPass: boolean = (mouseover && AppComponent.focusTableMouseOver)
      || (!mouseover && !AppComponent.focusTableMouseOver);
    if (canPass && !this.focused) {
      this.focused = true;
      if (rowIndex > 0) {
        this.focusedRowIndex = rowIndex;
      } else if (!this.focusedRowIndex || this.focusedRowIndex < 0) {
        this.focusedRowIndex = 0;
      }
    }
  }

  focusOut(mouseover = false) {
    const canPass: boolean = (mouseover && AppComponent.focusTableMouseOver)
      || (!mouseover && !AppComponent.focusTableMouseOver);
    if (canPass) {
      this.focused = false;
      // this.focusedRowIndex = -1;
    }
  }

  getVisibleColumns() : TableColumnConfig[]{
    return this.tableConfig.filter(value => !value.hidden);
  }

  scrollToTop() {
  }
}
